<template>
    <div>
        <img src="https://smart-resource.sikegroup.com/a7dba810c474ab7a96b995649a118b2a.png" style="margin-bottom:50px;"/>
        <div style="margin:-180px auto 100px;width:1200px;"><img style="width:100%;" src="@/assets/imgs/course/thinkingHead.png"/></div>
        <div class="course-content" style="position: relative;">
           
             <div class="course-content max-title" style="margin-bottom:-70px;border-bottom: none">
                <span>特色环节</span>
                <span>Characteristic games</span>
            </div>
            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn">数独游戏</button>
                </div>
            </div>
            <ul class="list-text">
                <li>
                    <div>世界范围内公认的对逻辑、推理能力进行练习的神器。我们将这一经典游戏进行了调整，从简单的4x4宫格开始，运用孩子们喜欢的元素进行实物操作，引导孩子们走进这扇神秘的大门。</div>
                </li>
            </ul>
            <ul class="list-text" style="display: flex;justify-content: space-between;align-items: center">
                <li>
                    <img style="margin-right:60px" src="@/assets/imgs/course/steam-2.png" alt="">
                </li>
            </ul>
            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn">填字游戏</button>
                </div>
            </div>
            <ul class="list-text" style="display: flex;justify-content: space-between;">
                <li>
                    <div>据英国《每日电讯报》网站报道经常玩填字游戏的人在注意力、推理能力和记忆力的任务中都表现得超出一般人。这一次，我们为3岁的孩子们专门打造的这套适合他们的题目，也希望能够让孩子们在游戏的过程中，扩展知识、提升思维能力。</div>
                </li>
                <li>
                    <img style="margin-left:80px;" src="@/assets/imgs/course/steam-3.png" alt="">
                </li>
            </ul>

            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn">视觉拼图</button>
                </div>
            </div>
            <ul class="list-text" style="display: flex;justify-content: space-between;">
                <li>
                    <img style="margin-left:80px;" src="@/assets/imgs/course/steam-4.png" alt="">
                </li>
                <li>
                    <div>视觉拼图是需要通过看图片，找出图片中缺少的部分，这个从立体到平面，从依靠具体实物到依靠空间想象来完成的拼图游戏，对孩子们来说绝对是一个新鲜的体验，能够非常有效的提高空间能力。</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name:'steam',
    data(){
        return{

        }
    }
}
</script>
<style lang="less" scoped>

        .content-item{
            border-top: 1px solid #F8B300;
        }
        .page-btn{
            background: #F8B300;
        }
        .max-title{
            color: #F8B300;
            border-bottom: 1px solid #F8B300;
        }
        .list-text{
            margin: 30px 0;
            color: #6A6767;
            font-size: 16px;
            font-family: Light;
            
            align-items: center;
            line-height: 26px;
            li{
                img{
                    margin-right: 15px;
                }
            }
        }
    
</style>